const variant = Object.freeze({
  GREEN: 'green',
  RED: 'red'
})

export { variant }
